
  import userController from '/home/builduser/work/aa8edf8c81f9ea6/packages/business-name-generator/src/components/BusinessNameGeneratorPoc/controller.ts';
  import createControllerWrapper from '@wix/yoshi-flow-editor/runtime/esm/pureControllerWrapper.js';

  
import wrapController from '@wix/yoshi-flow-editor-runtime/internal/viewerScript/ooi';


  
var createHttpClient = null;

  

  import { initI18n as initI18n } from '@wix/yoshi-flow-editor/runtime/esm/i18next/init';


  
const multilingualDisabled = false;

  

    var createExperiments = null;
    var createWidgetExperiments = null;
    


  var sentryConfig = {
    DSN: 'https://5097d69f43d74896a46ff0e0c5cbd085@sentry.wixpress.com/2404',
    id: '5097d69f43d74896a46ff0e0c5cbd085',
    projectName: 'business-name-generator-qg',
    teamName: 'funnel',
    errorMonitor: true,
  };

  var experimentsConfig = {"centralized":true,"scopes":[]};

  var translationsConfig = {"icuEnabled":true,"defaultTranslationsPath":"/home/builduser/work/aa8edf8c81f9ea6/packages/business-name-generator/src/assets/locales/messages_en.json","availableLanguages":["en","uk"]};

  var biConfig = null;

  var defaultTranslations = {"app.widget.welcome":"Welcome","app.settings.label":"Configure Widget","app.settings.tabs.main":"Main","app.settings.tabs.design":"Design","app.settings.defaults.greetingsPretext":"to","app.header.title":"Pick the name that’s right for you","app.header.subtitle":"Find a name that’s clear, unique and memorable.","app.mainForm.keyword.label":"Keyword","app.mainForm.keyword.placeholder":"Enter your ideas","app.mainForm.industry.label":"Industry","app.mainForm.industry.placeholder":"Enter your industry","app.mainForm.submit.text":"Generate Name","app.content.title":"Here are the names we found for {businessIdea}"};

  var fedopsConfig = null;

  import { createVisitorBILogger as biLogger } from '/home/builduser/work/aa8edf8c81f9ea6/packages/business-name-generator/target/generated/bi/createBILogger.ts';

  const controllerOptions = {
    sentryConfig,
    biConfig,
    fedopsConfig,
    experimentsConfig,
    biLogger,
    translationsConfig,
    persistentAcrossPages: false,
    appName: "business-name-generator-poc",
    componentName: "BusinessNameGeneratorPoc",
    appDefinitionId: "a8364e5f-42f3-4c53-b766-bd6f2972f516",
    componentId: "fe2a1c56-0ae4-48fd-856d-c5b0b696ca56",
    projectName: "business-name-generator",
    defaultTranslations,
    multilingualDisabled,
    shouldUseEssentials: true,
    withErrorBoundary: false,
    localeDistPath: "assets/locales"
  };

  const _controller = createControllerWrapper(userController, controllerOptions, {
    initI18n,
    createHttpClient,
    createExperiments,
  });

  export const wrap = wrapController;
  export const descriptor = {
    ...controllerOptions,
    id: controllerOptions.componentId,
    widgetType: "WIDGET_OUT_OF_IFRAME",
    controllerFileName: "/home/builduser/work/aa8edf8c81f9ea6/packages/business-name-generator/src/components/BusinessNameGeneratorPoc/controller.ts",
  };

  export const controller = _controller
  export default controller;
